import React, { useEffect } from 'react';

import EmptyState from '@adsk/alloy-react-empty-state';

import { useFormsContext } from './FormsProvider';
import { ACTIONS } from './helpers/reducers/forms';
import { useTranslation } from './i18n';

const FormsCustomPickerEmptyState = ({ dataViewProps }) => {
  const { t } = useTranslation();
  const { dispatch } = useFormsContext();
  useEffect(() => {
    dispatch({
      type: ACTIONS.UPDATE_FORM_TEMPLATE_CATEGORIES,
      payload: {
        templateCategories: dataViewProps?.templateCategories || [],
      },
    });
  }, [dispatch, dataViewProps]);

  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
      title={t('NO_FORMS')}
      description={t('NO_FORMS_DESCRIPTION')}
    />
  );
};

export default FormsCustomPickerEmptyState;
